import React, { useState, useEffect } from 'react';
import axios from 'axios';
function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }

const PLATFORMS = [
  { id:'fcm',  label:'Firebase (Android)',  icon:'🤖', fields:[{k:'projectId',l:'Project ID'},{k:'serverKey',l:'Server Key',type:'password'}] },
  { id:'apns', label:'Apple Push (iOS)',     icon:'📱', fields:[{k:'teamId',l:'Team ID'},{k:'keyId',l:'Key ID'},{k:'bundleId',l:'Bundle ID'},{k:'privateKey',l:'p8 Private Key',type:'textarea'}] },
  { id:'wns',  label:'Windows (WNS)',        icon:'🪟', fields:[{k:'packageSid',l:'Package SID'},{k:'clientSecret',l:'Client Secret',type:'password'}] },
];

export default function PushNotifications({ user }) {
  const [configs, setConfigs] = useState([]);
  const [msg, setMsg] = useState({ text:'', type:'' });
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [sendModal, setSendModal] = useState(false);
  const [devices, setDevices] = useState([]);
  const [selDevs, setSelDevs] = useState([]);
  const [sendMsg, setSendMsg] = useState('New commands available — please check in');
  const [sending, setSending] = useState(false);

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }
  useEffect(()=>{
    axios.get('/api/push/configs',auth()).then(r=>setConfigs(r.data)).catch(()=>{});
    axios.get('/api/agents',auth()).then(r=>setDevices(r.data.filter?r.data.filter(d=>!d.archivedAt):r.data)).catch(()=>{});
  },[]);

  async function save(e) {
    e.preventDefault(); setSaving(true);
    try {
      const plat = PLATFORMS.find(p=>p.id===editing);
      await axios.post('/api/push/configs',{ platform:editing, name:plat?.label, config:form, active:true },auth());
      flash(`${plat?.label||editing} push configured`); setEditing(null); setForm({});
      const r = await axios.get('/api/push/configs',auth()); setConfigs(r.data);
    } catch(e) { flash(e.response?.data?.error||'Failed','error'); } finally { setSaving(false); }
  }

  async function send() {
    if(!selDevs.length)return; setSending(true);
    try { const r = await axios.post('/api/push/send',{ deviceIds:selDevs, message:sendMsg },auth()); flash(`Sent to ${r.data.sent} device(s)`); setSendModal(false); setSelDevs([]); }
    catch(e) { flash('Failed','error'); } finally { setSending(false); }
  }

  return (
    <div style={{padding:24}}>
      {msg.text&&<div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:24}}>
        <div><h2 style={{margin:0,fontSize:20,fontWeight:700}}>Push Notifications</h2><p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Wake agents instantly via APNs, FCM, WNS — reduces latency from 5min poll to 5 seconds</p></div>
        <button onClick={()=>setSendModal(true)} style={{background:'#1e40af',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer'}}>📤 Send Push</button>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:14,marginBottom:24}}>
        {PLATFORMS.map(p=>{
          const cfg = configs.find(c=>c.platform===p.id);
          return (
            <div key={p.id} style={{background:'#fff',border:`2px solid ${cfg?.active?'#16a34a30':'#e2e8f0'}`,borderRadius:12,padding:18}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:10}}>
                <div style={{display:'flex',gap:10,alignItems:'center'}}>
                  <span style={{fontSize:28}}>{p.icon}</span>
                  <div><div style={{fontWeight:700,fontSize:14}}>{p.label}</div>
                    <span style={{background:cfg?.active?'#dcfce7':'#f1f5f9',color:cfg?.active?'#16a34a':'#94a3b8',borderRadius:4,padding:'1px 6px',fontSize:10,fontWeight:700}}>{cfg?.active?'CONFIGURED':'NOT SET'}</span>
                  </div>
                </div>
              </div>
              <button onClick={()=>{setEditing(p.id);setForm({});}} style={{width:'100%',background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:7,padding:'8px',fontSize:12,fontWeight:600,cursor:'pointer',color:'#475569'}}>
                {cfg?.active?'⚙ Reconfigure':'+ Configure'}
              </button>
            </div>
          );
        })}
      </div>
      <div style={{background:'#f0f9ff',border:'1px solid #bae6fd',borderRadius:10,padding:'14px 18px',fontSize:13}}>
        <span style={{fontWeight:700,color:'#0369a1'}}>How it works: </span>Agents call <code>POST /api/push/register</code> on startup with their push token. When you queue a remote action, the server sends a lightweight wake push so the agent polls immediately — no need to wait up to 5 minutes.
      </div>
      {editing&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:480,maxWidth:'95vw',maxHeight:'85vh',overflow:'auto'}}>
            <h3 style={{margin:'0 0 20px',fontSize:18,fontWeight:700}}>Configure {PLATFORMS.find(p=>p.id===editing)?.label}</h3>
            <form onSubmit={save}>
              {(PLATFORMS.find(p=>p.id===editing)?.fields||[]).map(f=>(
                <div key={f.k} style={{marginBottom:14}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>{f.l}</label>
                  {f.type==='textarea' ? <textarea value={form[f.k]||''} onChange={e=>setForm({...form,[f.k]:e.target.value})} rows={4} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:12,fontFamily:'monospace',boxSizing:'border-box'}} />
                  : <input type={f.type||'text'} value={form[f.k]||''} onChange={e=>setForm({...form,[f.k]:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} />}
                </div>
              ))}
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" onClick={()=>setEditing(null)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                <button type="submit" disabled={saving} style={{padding:'10px 20px',background:saving?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:saving?'default':'pointer'}}>{saving?'Saving...':'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {sendModal&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:460,maxWidth:'95vw'}}>
            <h3 style={{margin:'0 0 16px',fontSize:18,fontWeight:700}}>Send Push Notification</h3>
            <div style={{marginBottom:12}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Message</label>
              <input value={sendMsg} onChange={e=>setSendMsg(e.target.value)} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} /></div>
            <div style={{maxHeight:180,overflow:'auto',border:'1px solid #e2e8f0',borderRadius:8,marginBottom:14}}>
              {devices.map(d=><label key={d.id} style={{display:'flex',gap:8,padding:'7px 12px',borderBottom:'1px solid #f8fafc',cursor:'pointer',background:selDevs.includes(d.id)?'#eff6ff':'#fff'}}>
                <input type="checkbox" checked={selDevs.includes(d.id)} onChange={e=>setSelDevs(s=>e.target.checked?[...s,d.id]:s.filter(x=>x!==d.id))} />
                <span style={{flex:1,fontSize:13}}>{d.hostname}</span>
                <span style={{fontSize:11,color:d.status==='online'?'#16a34a':'#94a3b8',fontWeight:600}}>{d.status==='online'?'●':'○'}</span>
              </label>)}
            </div>
            <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
              <button onClick={()=>setSendModal(false)} style={{padding:'9px 18px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
              <button onClick={send} disabled={sending||!selDevs.length} style={{padding:'9px 18px',background:sending||!selDevs.length?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:sending?'default':'pointer'}}>{sending ? 'Sending...' : `Send to ${selDevs.length}`}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
